import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-reference',
    templateUrl: './reference.component.html',
    styleUrls: ['./reference.component.css']
})
export class ReferenceComponent implements OnInit {

    References: Array<any> = [
        { IconClass: "flaticon-brain", Header: "Basic Life Support", FileName: "MSOS Algorithm Sheets_Basic life support.pdf" },
        { IconClass: "flaticon-spine", Header: "Advanced Life Support", FileName: "MSOS Algorithm Sheets_Advanced life support.pdf" },
        { IconClass: "flaticon-skull", Header: "Loss of Conscious", FileName: "MSOS Algorithm Sheets_Loss of conciousness.pdf" },
        { IconClass: "flaticon-skull", Header: "Headache", FileName: "MSOS Algorithm Sheets_Headache.pdf" },
        { IconClass: "flaticon-cough", Header: "Choking", FileName: "MSOS Algorithm Sheets_Choking.pdf" },
        { IconClass: "flaticon-lungs", Header: "Shortness of Breath", FileName: "MSOS Algorithm Sheets_Shortness of breath.pdf" },
        { IconClass: "flaticon-scan", Header: "Shock and Haemorrhage", FileName: "MSOS Algorithm Sheets_Shock and haemorrhage.pdf" },
        { IconClass: "flaticon-science", Header: "Sepsis/Fever", FileName: "MSOS Algorithm Sheets_Sepsis & Fever.pdf" },
        { IconClass: "flaticon-first-aid-briefcase", Header: "Allergy/Anaphylaxis", FileName: "MSOS Algorithm Sheets_Allergy & Anaphylaxis.pdf" },
        { IconClass: "flaticon-cardiogram-1", Header: "Chest Pain/Heart Attack", FileName: "MSOS Algorithm Sheets_Chest pain & Heart attack.pdf" },
        { IconClass: "flaticon-sugar-blood-level", Header: "Diabetic Emergency", FileName: "MSOS Algorithm Sheets_Diabetic emergency.pdf" },
        { IconClass: "flaticon-fire", Header: "Burns", FileName: "MSOS Algorithm Sheets_Burns.pdf" },
    ];

    constructor() { }

    ngOnInit() { }

    ReadReference(page) {
        window.open('/assets/MedicalEmergencyHandbook.pdf', 'PDF');
    };

    ReadEmergencyAlgorithm(FileName: string) {
        window.open('/assets/Emergency Algorithm/' + FileName, 'PDF');
    }
}



// WEBPACK FOOTER //
// ./src/app/library/reference.component.ts